import React from "react";
import { Box, Container, Typography, Button, Grid, Card, CardMedia } from "@mui/material";
import { motion } from "framer-motion";

const users = [
  {
    type: "Structured Data Cabling",
    description: "Cat6, Cat6A, and Fiber Optic installation for reliable high-speed connectivity. We ensure certified, neat, and organized cable runs.",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bbcbf?auto=format&fit=crop&w=600&q=80",
    bg: "#f5f5f5",
  },
  {
    type: "Network Repair & Troubleshooting",
    description: "Expert diagnostics and repair for damaged lines, certification failures, and connectivity issues. We get your network back online fast.",
    image: "https://storage.googleapis.com/app_darkendimg/data-speedway/ethernet.mp4",
    bg: "#f5f5f5 ",
  },
  {
    type: "New Construction Wiring",
    description: "Complete low-voltage rough-in and trim-out for new builds and office expansions. We work with contractors to ensure timely delivery.",
    image: "https://images.unsplash.com/photo-1581092921461-eab62e97a782?auto=format&fit=crop&w=600&q=80",
    bg: "#f5f5f5",
  },
  {
    type: "Data Rack Installation & Organization",
    description: "MDF/IDF cleanup, cable management, and rack organization. We turn messy, unmanageable closets into professional data plants.",
    image: "https://storage.googleapis.com/app_darkendimg/data-speedway/racks.mp4",
    bg: "#f5f5f5",
  },
  {
    type: "Fiber Optic Splicing",
    description: "Precision fusion splicing and termination for backbone fiber links. reliable long-distance data transmission.",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bbcbf?auto=format&fit=crop&w=600&q=80",
    bg: "#f5f5f5",
  },
];

const HeroSection = () => (
  <Box
    sx={{
      position: "relative",

      height: { xs: "400px", sm: "500px", md: "600px" },
      overflow: "hidden",
    }}
  >
    {/* Video Background */}
    <video
      autoPlay
      loop
      muted
      playsInline
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      poster="https://storage.googleapis.com/app_darkendimg/assets/koffiehands.png" // fallback image
    >
      <source
        src="https://storage.googleapis.com/app_darkendimg/data-speedway/ethernet.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>

    {/* Content Overlay */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,

        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        p: { xs: 2, sm: 5 },
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Typography variant="h2" fontWeight="bold" sx={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
          Professional Ethernet Services
        </Typography>
        <Typography variant="h4" mt={2} sx={{ color: '#FACD00', textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
          Nationwide site surveys, heat mapping, and structured cabling installation.
        </Typography>
        <Box mt={4}>
          <Button variant="contained" sx={{ mr: 2, backgroundColor: '#facd00', color: '#000' }}>
            Get Started
          </Button>
          <Button variant="outlined" sx={{ borderColor: '#000', color: '#FACD00' }}>
            Learn More
          </Button>
        </Box>
      </motion.div>
    </Box>
  </Box>
);


const UserSection = ({ type, description, image, bg, index }) => {
  const isEven = index % 2 === 0;

  // Check if the URL points to a video
  const isVideo = image?.toLowerCase().endsWith('.mp4');

  // Create a renderMedia function to simplify the JSX below
  const renderMedia = () => {
    if (isVideo) {
      return (
        <CardMedia
          component="video"
          height="300"
          src={image} // This pulls from your JSON 'image' field
          sx={{
            borderRadius: '10px', // Use a string like '20px' or a number (MUI multiplier)
            backgroundColor: '#fff',
            overflow: 'hidden',   // Essential to clip the video to the border radius
            objectFit: 'cover'    // Ensures the video fills the area nicely
          }}
          autoPlay
          loop
          muted
          controls={false}
        />
      );
    }
    // Remember to return null or an <img> tag if isVideo is false
    return <CardMedia component="img" height="300" image={image} sx={{ borderRadius: 2, boxShadow: 3 }} />
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: isEven ? -100 : 100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <Box sx={{ backgroundColor: bg, py: 6 }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            {isEven ? (
              <>
                <Grid item xs={12} md={6}>
                  {renderMedia()}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: 0, borderRadius: 3, p: 3, bgcolor: 'transparent' }}>
                    <Typography variant="h4" fontWeight="bold">
                      {type}
                    </Typography>
                    <Typography variant="body1" mt={2} fontSize="1.1rem">
                      {description}
                    </Typography>
                  </Card>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: 0, borderRadius: 3, p: 3, bgcolor: 'transparent' }}>
                    <Typography variant="h4" fontWeight="bold">
                      {type}
                    </Typography>
                    <Typography variant="body1" mt={2} fontSize="1.1rem">
                      {description}
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  {renderMedia()}
                </Grid>
              </>
            )}
          </Grid>
        </Container>
      </Box>
    </motion.div>
  );
};

const BaristaPage = () => {
  return (
    <>
      <HeroSection />
      {users.map((user, index) => (
        <UserSection key={index} index={index} {...user} />
      ))}
    </>
  );
};

export default BaristaPage;
